import stage1Static from '../assets/images/fun-buddy/stages/stage-1.png'
import stage2Static from '../assets/images/fun-buddy/stages/stage-2.png'
import stage3Static from '../assets/images/fun-buddy/stages/stage-3.png'
import stage4Static from '../assets/images/fun-buddy/stages/stage-4.png'
import stage5Static from '../assets/images/fun-buddy/stages/stage-5.png'
import stage6Static from '../assets/images/fun-buddy/stages/stage-6.png'
import stage7Static from '../assets/images/fun-buddy/stages/stage-7.png'
import stage1Motion from '../assets/images/fun-buddy/motion/stage-1-motion.png'
import stage2Motion from '../assets/images/fun-buddy/motion/stage-2-motion.png'
import stage3Motion from '../assets/images/fun-buddy/motion/stage-3-motion.png'
import stage4Motion from '../assets/images/fun-buddy/motion/stage-4-motion.png'
import stage5Motion from '../assets/images/fun-buddy/motion/stage-5-motion.png'
import stage6Motion from '../assets/images/fun-buddy/motion/stage-6-motion.png'
import stage7Motion from '../assets/images/fun-buddy/motion/stage-7-motion.png'

const staticStages = Object.freeze([
  stage1Static,
  stage2Static,
  stage3Static,
  stage4Static,
  stage5Static,
  stage6Static,
  stage7Static
])

const motionStages = Object.freeze([
  stage1Motion,
  stage2Motion,
  stage3Motion,
  stage4Motion,
  stage5Motion,
  stage6Motion,
  stage7Motion
])

function stageIndex (stage) {
  return Math.max(0, Math.min(staticStages.length - 1, (Number(stage) || 1) - 1))
}

export const qilinMenuAssets = {
  pet: stage1Static,
  checkin: stage1Static,
  mission: stage1Static
}

export function qilinStageImage (stage) {
  return staticStages[stageIndex(stage)]
}

export function qilinPetImage (pet, allowAnimation = true) {
  const mood = pet && pet.mood ? pet.mood : 'new'
  const index = stageIndex(pet && pet.stage)
  if (mood === 'hungry' || mood === 'sulking' || !allowAnimation) return staticStages[index]
  return motionStages[index]
}
